/**
 * Created by aaikepae on 5/1/17.
 */


import React from "react";
import {parseLink} from "Common/utility/link"

//https://bitbucket.org/dp_content/devnet_content/src/504448f0dede6aa11a0dfe6b716d02054390822d/site/includes/structure/darwin/navs/megamenu/_technologies.gsp?at=master&fileviewer=file-view-default

const menuType = {
    "technology": "https://developer.cisco.com/site/includes/structure/darwin/navs/megamenu/_technologies.gsp",
    "discover": "https://developer.cisco.com/site/includes/structure/darwin/navs/megamenu/_discover.gsp",
    "support": "https://developer.cisco.com/site/includes/structure/darwin/navs/megamenu/_support.gsp",
    "community": "https://developer.cisco.com/site/includes/structure/darwin/navs/megamenu/_community.gsp",
};
const technologyDevCenterMap = {
    "networking": "https://developer.cisco.com/site/networking/",
    "iot": "https://developer.cisco.com/iot/",
    "cloud": "https://developer.cisco.com/site/cloud/",
    "data center": "https://developer.cisco.com/site/data-center/",
    "collaboration": "https://developer.cisco.com/site/collaboration/",
    "analytics and automation software": "https://developer.cisco.com/site/analytics-automation/",
    "security": "https://developer.cisco.com/site/security/",
    "opensource": "https://developer.cisco.com/site/opensource/",
    "mobility": "https://developer.cisco.com/site/mobility/"
};

export default class Breadcrumb extends React.Component {
    constructor() {
        super();
        this.jumpToAnchor = this.jumpToAnchor.bind(this);
    }

    jumpToAnchor(to, duration, offset, event) {
        try {
            PubHub.util.scrollTo(to, duration, offset);
        } catch (e) {

        }


        event.preventDefault();
        return false;
    }


    generateData(item) {
        const title = item.querySelector("title") ? item.querySelector("title").innerText.trim() : null;
        const url = item.querySelector("url") ? item.querySelector("url").innerText.trim() : null;
        const target = item.querySelector("target") ? item.querySelector("target").innerText.trim() : "_self";
        const to = item.querySelector("to") ? item.querySelector("to").innerText.trim() : null;
        const duration = item.querySelector("duration") ? item.querySelector("duration").innerText.trim() : 600;
        const offset = item.querySelector("offset") ? item.querySelector("offset").innerText.trim() : 0;
        const ref = item.getAttribute("ref");


        return {title, url, target, ref, to, duration, offset}
    }


    generateLink(item, location, index) {
        const {title, url, target, ref, to, duration, offset} = this.generateData(item);

        if (!title) {
            return null
        }

        if (to) {

            return <li key={index}>
                <a href="#" title={title}
                   className="pubhub-breadcrumb-link "
                   data-ref={ref}
                   data-track-name="breadcrumb:item:link"
                   data-track-value={title}
                   onClick={(e) => this.jumpToAnchor(to, duration, offset, e)}
                >
                    {title}
                </a>
            </li>
        }


        return <li key={index}><a href={parseLink(url, location, this.props.context)} title={title}
                                  className="pubhub-breadcrumb-link "
                                  target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} data-ref={ref} data-track-name="breadcrumb:item:link"
                                  data-track-value={title}>{title}</a></li>
    }

    _parseConfig(config, meta) {
        // fix typo and backward compatible
        let showMenu = config.querySelector("showyMenu") ? config.querySelector("showyMenu").innerText.trim() === "true" : true;
        if (config.querySelector("showMenu")) {
            showMenu = config.querySelector("showMenu").innerText.trim() === "true"
        }


        const subType = config.querySelector("subType") ? config.querySelector("subType").innerText.trim() : null;
        const menuType = config.querySelector("menuType") ? config.querySelector("menuType").innerText.trim() : "Technology";
        const name = config.querySelector("projectName") ? config.querySelector("projectName").innerText.trim() : meta["name"];

        const breadcrumbNavigation = config.querySelector("breadcrumbNavigation") ? config.querySelector("breadcrumbNavigation").innerText.trim() : null;

        return {showMenu, subType, menuType, name, breadcrumbNavigation}
    }


    generateBreadCrumb(config, meta) {

        const {showMenu, subType, menuType, name, breadcrumbNavigation} = this._parseConfig(config, meta);

        let navi = null;

        if (breadcrumbNavigation) {
            try {

                const _breadcrumbNavigation = JSON.parse(breadcrumbNavigation);

                const items = _breadcrumbNavigation.map((item, index) => {
                    const target = item["target"] || "_self";
                    return <li className="pubhub-breadcrumb-breadcrumb-navi-title pubhub-breadcrumb-breadcrumb-arrow"
                               key={index}>
                        <a href={item["url"] || "#"} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>{item.title}</a>
                    </li>;
                });

                navi = <ul>{items}</ul>;
            } catch (e) {
                console.error(e)
                navi = null
            }
        } else {
            const subType_link = subType && technologyDevCenterMap[subType.toLowerCase()];

            const technologyMenu_el = showMenu ? <li><a href="">{menuType}</a></li> : null;
            const technology_el = (showMenu && subType) ?
                <li className="pubhub-breadcrumb-breadcrumb-arrow"><a href={subType_link}>{subType}</a></li> : null;
            const title_el = !showMenu ?
                <li className="pubhub-breadcrumb-breadcrumb-large-title"><a href="./">{name}</a></li> :
                <li className="pubhub-breadcrumb-breadcrumb-title pubhub-breadcrumb-breadcrumb-arrow"><a
                    href="./">{name}</a>
                </li>;

            navi = <ul>
                {technologyMenu_el}
                {technology_el}
                {title_el}
            </ul>
        }


        return <div className="col-auto pubhub-breadcrumb-breadcrumb hidden-sm-down">{navi}</div>
    }


    render() {


        const {config, location, type} = this.props;

        if (!config) {
            return <span>Loading</span>
        }

        const meta = this.props.context.props.meta;

        const links = config.querySelectorAll("sitenavigation > *");

        const links_el = Array.from(links || []).map((item, index) => {
            return this.generateLink(item, location, index);
        });


        const breadcrumb = this.generateBreadCrumb(config, meta);

        return (
            <div className="pubhub-breadcrumb">
                <div className="container">
                    <div className="row pubhub-breadcrumb-nav">
                        {breadcrumb}
                        <div className="col pubhub-breadcrumb-links align-items-end">
                            <ul>
                                {links_el}
                            </ul>

                        </div>
                    </div>

                </div>
            </div>

        );
    }
}
